import React from "react";
import styled from "styled-components";
import ActionButton from "../../../../elements/ActionButton";

const Container = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: center;
`;

const CloseActionButton = ({onClose, openPortfolios, closeInProgress}) => {
    const number = openPortfolios.length;

    return <ActionButton className="t-idea-action-button"
                         disabled={closeInProgress}
                         isLoading={closeInProgress}
                         onClick={onClose}>
        {`Close for ${number} portfolio${number > 1 ? 's' : ''}`}
    </ActionButton>
};

const UpdateActionButton = ({onUpdate, openPortfolios, updateInProgress, hasCommentary}) => {
    const number = openPortfolios.length;
    if (!hasCommentary) {
        return <ActionButton className="t-idea-action-button"
                             disabled={true}
                             isLoading={updateInProgress}>
            {`Update for ${number} portfolio${number > 1 ? 's' : ''}`}
        </ActionButton>;
    }

    return <ActionButton className="t-idea-action-button"
                         disabled={updateInProgress}
                         isLoading={updateInProgress}
                         onClick={onUpdate}>
        {`Update for ${number} portfolio${number > 1 ? 's' : ''}`}
    </ActionButton>
};

const DisabledUpdateButton = () => {
    return <ActionButton className="t-disabled-idea-action-button" disabled={true}>
        Update
    </ActionButton>
};

const IdeaActionButton = ({onUpdate, onClose, commentary, selectedAction, openPortfolios, closeInProgress, updateInProgress}) => {
    let actionButton;
    if (!selectedAction) {
        actionButton = <DisabledUpdateButton/>;
    } else if (selectedAction === "close") {
        actionButton = <CloseActionButton onClose={onClose}
                                          closeInProgress={closeInProgress}
                                          openPortfolios={openPortfolios}/>
    } else {
        actionButton = <UpdateActionButton onUpdate={onUpdate}
                                           hasCommentary={!!commentary}
                                           updateInProgress={updateInProgress}
                                           openPortfolios={openPortfolios}/>;
    }

    return <Container>
        {actionButton}
    </Container>;
};

export default IdeaActionButton;